import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CorporateForm from '../components/RegisterFormCoorporate';
import IndividualForm from '../components/RegisterFormIndividual';
import { CORPORATE_TYPE, INDIVIDUAL_TYPE } from '../constants';
import SignUp from '../containers/SignUpCard';
import RegisterType from '../containers/RegisterType';
import VerifyPinCard from '../containers/VerifyPin';
import ConfirmCard from '../components/ConfirmCard';
import { ROUTES } from '../constants/Routes';
import registerService from '../utils/services/registerService';
import { useSelector, useDispatch } from 'react-redux';
import { register } from '../utils/redux/actions/registerAction';
import HomeLayout from '../containers/menu/HomeLayout';
import { Notification } from '../../src/components/Notification';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import { Spin } from 'antd';
import { instance } from '../components/AxiosClient';
import GetProfile from '../components/VariableStore';
import _ from 'lodash';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';

const RegisterPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const isDesktop = useIsDesktop;
  // //console.log("RegisterPage redux state", state);

  const [step, setStep] = useState(1);
  const [type, setType] = useState();
  // step 1 -> choose type
  // step 2 -> register form
  // step 3 -> verify code (only individual)
  // step 4 -> success
  const [profilePic, setProfilePic] = useState([]);
  const [profileDoc, setProfileDoc] = useState([]);
  const [name, setName] = useState('');
  const [taxNo, setTaxNo] = useState('');
  const [address, setAddress] = useState('');
  const [contact, setContact] = useState('');
  const [customerType, setCustomerType] = useState([]);
  const [selectCustomerType, setSelectCustomerType] = useState('');
  const [phone, setPhone] = useState('');
  const [phoneCom, setPhoneCom] = useState('');
  const [email, setEmail] = useState('');
  const [emailCus, setEmailCus] = useState('');
  const [password, setPassword] = useState('');
  const [passwordCf, setPasswordCf] = useState('');
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [isCorporate, setIsCorporate] = useState(false);
  const [verifyCode, setVerifyCode] = useState('');
  const [errorValidate, setErrorValidate] = useState('');
  const [errorValidateType, setErrorValidateType] = useState('');
  const [errorValidatePhone, setErrorValidatePhone] = useState('');
  const [errorValidatePassword, setErrorValidatePassword] = useState('');
  const [errorDigitPassword, setErrorDigitPassword] = useState('');
  const [isCheck, setIsCheck] = useState(false);
  const [loading, setLoading] = useState(false);
  const intl = useIntl();

  useEffect(() => {
    if (type === CORPORATE_TYPE) {
      getCustomnerType();
    }
  }, [type]);

  const getCustomnerType = async () => {
    const _registerService = new registerService();

    await _registerService
      .getCustomType()
      .then((response) => {

        const customcom = _.remove(response.data, {
          customerTypeId: process.env.REACT_APP_CUSTOMERTYPE_INDIVIDUL,
        });
        setCustomerType(response.data);
      })
      .catch((err) => {
        //console.log('getCustomerProfile err:', err);
      });
  };

  const handleChooseType = (choosedType) => {
    setType(choosedType);
    setStep(2);
  };

  const handleClickBack = () => {
    setStep(1);
  };

  const handleClickCancel = () => {
    navigate(ROUTES.Login);
  };

  const handleNavigateToLogin = () => {
    navigate(ROUTES.Login);
  };

  const handleClickAcceptPolicy = () => {
    setAcceptPolicy(!acceptPolicy);
    //console.log('acceptPolicy: ', acceptPolicy);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const newStep = type === INDIVIDUAL_TYPE ? 3 : 4;
    //console.log('newStep', newStep);
    const _registerService = new registerService();
    let body;
    if (type === CORPORATE_TYPE) {
      //console.log('handleSubmit type: ', type, 'isCorporate = ', isCorporate, 'selectCustomerType', selectCustomerType);
      body = {
        name: `${name} • ${contact}`,
        taxNo: taxNo,
        contactName: contact,
        phone: phone,
        email: email,
        password: '',
        passwordConfirm: '',
        isCorporate: true,
        privacyPolicyStatus: acceptPolicy,
        customerTypeId: selectCustomerType,
      };
    } else {
      body = {
        name: name,
        taxNo: taxNo,
        //contactName: contact,
        // contactPhone: phone,
        phone: phone,
        email: email,
        password: password,
        passwordConfirm: passwordCf,
        isCorporate: false,
        privacyPolicyStatus: acceptPolicy,
        customerTypeId: process.env.REACT_APP_CUSTOMERTYPE_INDIVIDUL,
      };
    }
    //console.log('handleSubmit body: ', body);
    await _registerService
      .register(body)
      .then(async (response) => {
        //console.log('signin response:', response);
        setStep(newStep);
        dispatch(register(response.data.id, response.data.referenceCode));
        if (type === CORPORATE_TYPE) {
          if (profilePic.length != 0) {
            const bodyUploadFile = {
              uploadType: 'profile',
              file: profilePic,
            };
            await _registerService.registerUploadFile(response.data.id, bodyUploadFile);
          }
          if (profileDoc.length > 0) {
            for (const doc of profileDoc) {
              const bodyUploadFile = {
                uploadType: 'document',
                file: doc.imageCustomerDoc,
              };
              await _registerService.registerUploadFile(response.data.id, bodyUploadFile);
            }
          }
        } else {
          if (profilePic.length != 0) {
            const bodyUploadFile = {
              uploadType: 'profile',
              file: profilePic,
            };
            await _registerService.registerUploadFile(response.data.id, bodyUploadFile);
          }
          if (profileDoc.length > 0) {
            for (const doc of profileDoc) {
              const bodyUploadFile = {
                uploadType: 'document',
                file: doc.imageCustomerDoc,
              };
              await _registerService.registerUploadFile(response.data.id, bodyUploadFile);
            }
          }
        }
      })
      .catch((err) => {
        if (err.status.code === 400) {
          setStep(2);
          Notification('error', err.status.message);
        } else {
          setStep(2);
          Notification('error',intl.formatMessage({ id: 'notificationFaliedRegister', defaultMessage: 'Failed to register' }) );
        }
        //console.log('signin err:', err);
      });
    setLoading(false);
  };

  const handleClickVerify = async () => {
    setLoading(true);
    setIsCorporate(false);
    const _registerService = new registerService();
    const body = {
      referenceCode: state.registerReducer.ref,
      code: verifyCode,
    };
    //console.log('handleClickVerify body: ', body);
    await _registerService
      .verify(body, state.registerReducer.id)
      .then(async (response) => {
        setStep(4);
        //console.log('verify response:', response);
        //console.log('profilePic', profilePic);
        if (profilePic.length === 1) {
          const bodyUploadFile = {
            uploadType: 'profile',
            file: profilePic,
          };
          await _registerService.registerUploadFile(response.data.id, bodyUploadFile);
        }
      })
      .catch((err) => {
        setStep(3);
        Notification('error',intl.formatMessage({ id: 'notificationErrorVerification', defaultMessage: 'Incorrect Verification Code, Please try again.' }));
        //console.log('verify err:', err);
      });
    setLoading(false);
  };

  const handleCancelVerify = () => {
    setStep(2);
  };

  let content = <div />;
  switch (step) {
    case 2:
      content = (
        <SignUp
          onSubmit={handleSubmit}
          onCancel={handleClickCancel}
          onBack={handleClickBack}
          onAcceptPolicy={handleClickAcceptPolicy}
          type={type}
          name={name}
          selectCustomerType={selectCustomerType}
          taxNo={taxNo}
          phone={phone}
          password={password}
          passwordCf={passwordCf}
          contact={contact}
          email={email}
          acceptPolicy={acceptPolicy}
          errorValidate={errorValidate}
          setName={setName}
          setPhone={setPhone}
          setEmail={setEmail}
          setPassword={setPassword}
          setPasswordCf={setPasswordCf}
          setAcceptPolicy={setAcceptPolicy}
          setErrorValidate={setErrorValidate}
          setAddress={setAddress}
          setContact={setContact}
          setTaxNo={setTaxNo}
          setPhoneCom={setPhoneCom}
          phoneCom={phoneCom}
          setIsCheck={setIsCheck}
          isCheck={isCheck}
        >
          {type === INDIVIDUAL_TYPE ? (
            <IndividualForm
              setProfilePic={setProfilePic}
              setName={setName}
              name={name}
              setPhone={setPhone}
              phone={phone}
              setEmail={setEmail}
              email={email}
              setPassword={setPassword}
              password={password}
              setPasswordCf={setPasswordCf}
              passwordCf={passwordCf}
              setAcceptPolicy={setAcceptPolicy}
              acceptPolicy={acceptPolicy}
              setErrorValidate={setErrorValidate}
              errorValidate={errorValidate}
              setErrorValidatePassword={setErrorValidatePassword}
              errorValidatePassword={errorValidatePassword}
              setErrorValidatePhone={setErrorValidatePhone}
              errorValidatePhone={errorValidatePhone}
              setErrorDigitPassword={setErrorDigitPassword}
              errorDigitPassword={errorDigitPassword}
              setIsCheck={setIsCheck}
              isCheck={isCheck}
            ></IndividualForm>
          ) : (
            <CorporateForm
              setProfilePic={setProfilePic}
              setProfileDoc={setProfileDoc}
              setName={setName}
              name={name}
              setTaxNo={setTaxNo}
              customerType={customerType}
              selectCustomerType={selectCustomerType}
              setSelectCustomerType={setSelectCustomerType}
              taxNo={taxNo}
              setAddress={setAddress}
              address={address}
              setContact={setContact}
              contact={contact}
              setPhone={setPhone}
              phone={phone}
              setEmail={setEmail}
              email={email}
              setErrorValidate={setErrorValidate}
              errorValidate={errorValidate}
              setIsCheck={setIsCheck}
              isCheck={isCheck}
              errorValidateType={errorValidateType}
              setErrorValidateType={setErrorValidateType}
            ></CorporateForm>
          )}
        </SignUp>
      );
      break;
    case 3:
      content = (
        <VerifyPinCard
          onVerify={handleClickVerify}
          setVerifyCode={setVerifyCode}
          verifyCode={verifyCode}
          phone={phone}
          isDesktop={isDesktop}
          handleCancelVerify={handleCancelVerify}
        />
      );
      break;
    case 4:
      content =
        type === CORPORATE_TYPE ? (
          <ConfirmCard
            title={intl.formatMessage({ id: 'titleSubmitted', defaultMessage: 'Submitted' })}
            description={intl.formatMessage({ id: 'descriptionSubmit', defaultMessage: 'Your application has been successfully submitted. We will get back to you as soon as possible.' })}
            textButton={intl.formatMessage({ id: 'textButtonSumbmit', defaultMessage: 'Back to Sign In' })}
            onConfirm={handleNavigateToLogin}
          />
        ) : (
          <ConfirmCard
            title={intl.formatMessage({ id: 'titleVerified', defaultMessage: 'Verified' })}
            description={intl.formatMessage({ id: 'descriptionVerified', defaultMessage: 'You have successfully verified the account.' })}
            textButton={intl.formatMessage({ id: 'textButtonSumbmit', defaultMessage: 'Back to Sign In' })}
            onConfirm={handleNavigateToLogin}
          />
        );
      break;
    case 1:
    default:
      content = <RegisterType onChooseType={handleChooseType} />;
      break;
  }

  return (
    <HomeLayout>
      <Spin spinning={loading}>{content}</Spin>
    </HomeLayout>
  );
};

export default RegisterPage;
